<template>
  <div
    v-if="!showPokemon"
    class="col-12 d-flex justify-content-around align-items-center"
  >
    <img
      :src="imgSrc"
      alt="pokemon image"
      class="hidden-pokemon img-fluid"
      width="250"
    />
    <div class="poke-font-solid font-size-24 text-center">
      ?
      <br />
      PoKéMoN
    </div>
  </div>
  <div v-else class="col-12 d-flex justify-content-around align-items-center">
    <img :src="imgSrc" alt="pokemon image" class="fade-in" width="250" />
    <div class="text-primary poke-font-normal font-size-24">
      {{ pokemon.name }}!
    </div>
  </div>
</template>

<script>
export default {
  name: 'PokemonPicture',
  props: {
    pokemon: {
      type: Object,
      required: true,
    },
    pokemonId: {
      type: Number,
      required: true,
    },
    showPokemon: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    imgSrc() {
      return `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/dream-world/${this.pokemonId}.svg`
    },
  },
}
</script>

<style scoped lang="scss">
img {
  // height: 200px;
  // position: absolute;
  /* right: 32%; */
  // width: 100vw;
  // margin-left: -50vw;
  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
}
.hidden-pokemon {
  filter: brightness(0);
}
</style>
